import React from "react";
import { Info, Check } from "lucide-react";
import { SCROLL_OFFSET } from "./sections";

const DICTIONARY_ROWS = [
  { label: "Custom word", value: "Zero Typing" },
  { label: "Preferred spelling", value: "Zero Typing AI" },
];

const VoiceToTextTrustSection = () => {
  return (
    <section
      id="voice-to-text-trust"
      style={{ scrollMarginTop: `${SCROLL_OFFSET}px` }}
      className="w-full lg:max-w-[815.58px]"
    >
      <h2 className="font-jakarta font-bold text-[#0A0D16] text-[28px] sm:text-[36px] md:text-[44px] lg:text-[50px] leading-[1.28] lg:leading-[64px] tracking-[-0.8px]">
        Voice to Text Google Docs Users Can Actually Trust
      </h2>

      <p className="mt-[25.76px] font-inter text-[16px] font-normal leading-[29.6px] tracking-[0px] text-[#0A0D16B2]">
        The biggest complaint about Google&apos;s built-in dictation isn&apos;t
        speed. It&apos;s accuracy. Names, industry terms, acronyms, and anything
        slightly outside everyday vocabulary tend to come out wrong — which
        means more time proofreading than you saved by talking.
      </p>

      <p className="mt-[25.76px] font-inter text-[16px] font-normal leading-[29.6px] tracking-[0px] text-[#0A0D16B2]">
        Zero Typing AI is built around a more accurate speech engine, so you
        spend less time cleaning up transcription errors and more time actually
        writing. That matters most for specialized content: legal notes, medical
        documentation, technical reports, or marketing copy full of brand names.
      </p>

      {/* 2 boxes part — 30.05px top padding, single row of 2 with 21.46px gutters */}
      <div className="pt-[30.05px]">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-[21.46px] items-stretch">
          {/* Left: personal dictionary preview */}
          <article className="rounded-[17.17px] border-[1.34px] border-[#E6ECF5] bg-[#F7FAFF] p-[16px] sm:p-[21.46px]">
            <p className="h-[18px] font-jakarta text-[11px] font-semibold uppercase leading-[18px] tracking-[0.12em] text-[#0A0D1699]">
              Personal Dictionary
            </p>

            <div className="mt-[12.88px] overflow-hidden rounded-[12px] border-[1.07px] border-[#E6ECF5] bg-white">
              {DICTIONARY_ROWS.map(({ label, value }) => (
                <div
                  key={label}
                  className="flex items-center justify-between gap-3 border-b-[1.07px] border-[#E6ECF5] px-[14px] py-[14px]"
                >
                  <span className="font-jakarta text-[13px] font-normal leading-[20px] text-[#0A0D1699]">
                    {label}
                  </span>
                  <span className="font-jakarta text-[13px] font-bold leading-[20px] text-[#0A0D16] text-right">
                    {value}
                  </span>
                </div>
              ))}

              <div className="flex items-center justify-between gap-3 px-[14px] py-[14px]">
                <span className="font-jakarta text-[13px] font-normal leading-[20px] text-[#0A0D1699]">
                  Status
                </span>
                <span className="flex items-center gap-1.5 font-jakarta text-[13px] font-medium leading-[20px] text-[#3AB1F6] text-right">
                  <Check className="h-[14px] w-[14px] shrink-0" strokeWidth={2.5} />
                  Added to dictionary
                </span>
              </div>
            </div>
          </article>

          {/* Right: explanatory callout */}
          <article className="flex flex-col justify-center rounded-[17.17px] border-[1.34px] border-[#3AB1F633] bg-[#EBF7FE] p-[16px] sm:p-[21.46px]">
            <span className="flex text-[#3AB1F6]">
              <Info className="h-[18px] w-[18px]" strokeWidth={1.8} />
            </span>

            <p className="mt-[12.88px] font-jakarta text-[14px] font-normal leading-[24px] tracking-[0px] text-[#3AB1F6]">
              Words that are misspelled or need a specific spelling can be added
              to the dictionary. Once added, they will always be transcribed
              exactly like that.
            </p>
          </article>
        </div>
      </div>
    </section>
  );
};

export default VoiceToTextTrustSection;
